import { shouldShowRscLibp } from "@faire/retailer-visitor-shared/views/brand/utils/shouldShowRscLibp";
import { QueryParameters as BrandPageQueryParams } from "@faire/web-api--source/routes/brand/brandToken";
import { getBrandPageLoadKey } from "@faire/retailer-visitor-shared/nextjs-rsc-util/getBrandPageLoadKey";
import { isBrandPageRoute } from "@faire/retailer-visitor-shared/nextjs-rsc-util/isBrandPageRoute";
var extractBrandToken = function(pathname) {
    var matches = pathname.match(/\/brand\/(b_[a-z0-9]+)/i);
    var _matches_;
    return (_matches_ = matches === null || matches === void 0 ? void 0 : matches[1]) !== null && _matches_ !== void 0 ? _matches_ : "";
};
// Only request RSC payload on filter, search term, page number, and spellcheck change to URL on search and discover pages
export var getShouldRequestRSCOnBrandPage = function(options) {
    var prevSearch = options.prevSearch, pathname = options.pathname, search = options.search;
    var brandToken = extractBrandToken(pathname);
    var prevBrandPageLoadKey = buildBrandPageLoadKey({
        brandToken: brandToken,
        search: prevSearch
    });
    var pageBrandPageLoadKey = buildBrandPageLoadKey({
        brandToken: brandToken,
        search: search
    });
    return shouldShowRscLibp() && isBrandPageRoute(pathname, search) !== null && pageBrandPageLoadKey !== prevBrandPageLoadKey;
};
var buildBrandPageLoadKey = function(options) {
    var brandToken = options.brandToken, search = options.search;
    var parsedBrandPage = BrandPageQueryParams.parse(search);
    var _parsedBrandPage_q, _parsedBrandPage_filters, _parsedBrandPage_page, _parsedBrandPage_collections;
    return getBrandPageLoadKey({
        brandToken: brandToken !== null && brandToken !== void 0 ? brandToken : "",
        query: (_parsedBrandPage_q = parsedBrandPage.q) !== null && _parsedBrandPage_q !== void 0 ? _parsedBrandPage_q : "",
        filters: (_parsedBrandPage_filters = parsedBrandPage.filters) !== null && _parsedBrandPage_filters !== void 0 ? _parsedBrandPage_filters : "",
        pageNumber: (_parsedBrandPage_page = parsedBrandPage.page) !== null && _parsedBrandPage_page !== void 0 ? _parsedBrandPage_page : "",
        collections: (_parsedBrandPage_collections = parsedBrandPage.collections) !== null && _parsedBrandPage_collections !== void 0 ? _parsedBrandPage_collections : ""
    });
};
